<template>
	<div class='knd-custom-animation' >
    <svg  viewBox="0 0 322 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0L8 1103" stroke="url(#paint0_linear_329_296)" stroke-width="2"/>

      <circle r="3" fill="white" id="p1">
          <animateMotion
            dur="10"
            fill="white"
            repeatCount="indefinite"
            path="M7 0L8 1103" />
        </circle>

        <defs>
          <linearGradient id="paint0_linear_329_296" x1="36" y1="15.0196" x2="130.008" y2="1124.72" gradientUnits="userSpaceOnUse">
            <stop stop-color="#575757"/>
            <stop offset="0.475" stop-color="#878787"/>
            <stop offset="1" stop-color="#575757"/>
          </linearGradient>
        </defs>
      </svg>

	</div>
</template>

<script>

export default {
  props: [],
  setup () {

    return {
    }
  }
}
</script>


<style lang="scss">
.knd-custom-animation {
  position: absolute;
  width: 100%;
  top: 35px;

  @include md { 
    display: none;
  }
  svg {
    width: 100%;

    circle {
      box-shadow: 0px 0px 3px 1px #FFFFFF;
      filter: blur(1px);
    }
  }
}

</style>